module.exports = __webpack_public_path__ + "img/consultoria_3-4_2304.03df0cd9.jpg";